
<div class="admin-card-container" ngbDropdown #adminDrop="ngbDropdown">
  <div class="admin-card" id="appsCard" ngbDropdownToggle>
    <span class="fa-solid fa-user-shield" title="Admin"></span>
  </div>
  <!--<div ngbDropdownMenu aria-labelledby="adminCard" class="admin-card-menu">

    <ng-container [ngTemplateOutlet]="templateMenuDD"
                  [ngTemplateOutletContext]="{ items : menuItems, level: 1 }">

    </ng-container>
  </div>-->
  <div ngbDropdownMenu aria-labelledby="userCard">

    <div *ngIf="enableRoles" class="dd-menu-item"><a class="dd-menu-item" href="/admin/roles" target="_parent" ngbDropdownItem>Roles</a></div>
    <div *ngIf="enableUsers" class="dd-menu-item"><a class="dd-menu-item" href="/admin/users" target="_parent" ngbDropdownItem>Users</a></div>
    <div *ngIf="enableFeatures" class="dd-menu-item"><a class="dd-menu-item" href="/admin/features" target="_parent" ngbDropdownItem>Features</a></div>
    <div *ngIf="enableAiHub" class="dd-menu-item"><a class="dd-menu-item" href="/admin/ai" target="_parent" ngbDropdownItem>AI</a></div>

    <div *ngIf="enableTaxonomy" class="dd-menu-item"><a class="dd-menu-item" href="/salesanddeliveryhub/Taxonomy" target="_parent" ngbDropdownItem>S&D Taxonomy</a></div>
    <div *ngIf="enableUploadFiles" class="dd-menu-item"><a class="dd-menu-item" href="/salesanddeliveryhub/UploadFiles" target="_parent" ngbDropdownItem>S&D Upload Files</a></div>
    <div *ngIf="enableIdeaverseList" class="dd-menu-item"><a class="dd-menu-item" href="/ideaverse/list" target="_parent" ngbDropdownItem>Ideaverse List</a></div>
    <div *ngIf="enableCuration" class="dd-menu-item"><a class="dd-menu-item" href="smartbank/curation" target="_parent" ngbDropdownItem>Smartbank Curation</a></div>


    <div *ngIf="enableWordOfTheWeek" class="dd-menu-item"><a class="dd-menu-item" href="wordoftheweek/curation" target="_parent" ngbDropdownItem>Create Word of The Month</a></div>
    <div *ngIf="enablePageBuilder" class="dd-menu-item"><a class="dd-menu-item" href="/pagebuilder/Projects" target="_parent" ngbDropdownItem>Page Builder</a></div>
    <div class="dd-menu-separator"></div>
    <!--<div class="dd-menu-header">Logs</div>-->
  </div>
</div>
